import Blue from "~/core";

import "../vendor/_import-jquery";
import "jquery-ui-dist/jquery-ui.js";

import { format } from "date-fns";

const MEMBERSHIP_FORM_SELECTOR = '.form-membershipprequalification';
const MEMBERSHIP_FORM_DUMMY_ID = '#memberform';

new Blue({
	name: 'Form Validate',
	selector: ".form--validate",
	setup(form) {
		this.$validate(form);
	}
});

// Add arrow styling to selects on formbuilder forms
new Blue({
	name: 'Select Arrow',
	selector: ".blue-form .editing-form-control-nested-control select",
	setup(select) {
		const parent = select.closest(".editing-form-control-nested-control");
		const arrowSpan = parent.querySelector("span.select-arrow") || false;
		if (!arrowSpan) {
			let span = document.createElement("span");
			span.classList.add("select-arrow");
			select.insertAdjacentElement("afterend", span);
		}
	}
});

// Add today link next to datepicker inputs
new Blue({
	name: 'Today Link for Datepicker',
	selector: ".date-time-picker > span",
	setup(parentSpan) {
		const container = parentSpan.closest(".date-time-picker");
		const todayLink = document.createElement("a");
		todayLink.setAttribute("id", parentSpan.getAttribute("id") + "_btnNow");
		todayLink.setAttribute("class", "calendar-action form-control-text");
		todayLink.textContent = "Today";
		const controlInner = container.querySelector(".control-group-inline");
		controlInner.appendChild(todayLink);
	}
});

new Blue({
	name: 'Form jQuery UI Datepicker',
	selector: ".date-time-picker",
	setup(container) {

		// hijack jquery-ui function _gotoToday so clicking the today button selects today's date,
		// instead of just showing/highlighting it
		$.datepicker._gotoToday = function(id) {
			var target = $(id);
			var inst = this._getInst(target[0]);
			if (this._get(inst, 'gotoCurrent') && inst.currentDay) {
				inst.selectedDay = inst.currentDay;
				inst.drawMonth = inst.selectedMonth = inst.currentMonth;
				inst.drawYear = inst.selectedYear = inst.currentYear;
			}
			else {
				var date = new Date();
				inst.selectedDay = date.getDate();
				inst.drawMonth = inst.selectedMonth = date.getMonth();
				inst.drawYear = inst.selectedYear = date.getFullYear();
				// the below two lines are new
				this._setDateDatepicker(target, date);
				this._selectDate(id, this._getDateDatepicker(target));
			}
			this._notifyChange(inst);
				this._adjustDate(target);
		}

		// Initialize datepicker
		const parentSpan = container.querySelector("span");
		const $datepickerInput = $(`.date-time-picker #${parentSpan.getAttribute("id")} input.form-control`);
		$datepickerInput.datepicker({
      		showButtonPanel: true,
      		changeMonth: true,
      		changeYear: true,
			showAnim: "fadeIn",
      		showOn: "button",
			buttonText: "",
			dateFormat: "m/d/yy",
			closeText: "Select",
			showOtherMonths: true,
			selectOtherMonths: true,
		});

		// Add calendar icon to button to match prod
		const datepickerButton = container.querySelector(".ui-datepicker-trigger");
		datepickerButton.setAttribute("class", "icon-only btn-icon btn");
		datepickerButton.setAttribute("aria-label", "Open calendar");

		const calendarIcon = document.createElement("i");
		calendarIcon.classList.add("icon-calendar");
		calendarIcon.setAttribute("aria-hidden", "true");
		datepickerButton.appendChild(calendarIcon);

		// Functionality for Today link next to input
		const todayLink = container.querySelector(".calendar-action.form-control-text");
		this.$addEvents(todayLink, "click.prevent", () => {
      let todaysDate = new Date();
      todaysDate = format(todaysDate, "M/d/yyyy");
			$datepickerInput.datepicker("setDate", todaysDate);
		});

	}
});

new Blue({
	name: 'Membership Prequalification Form', 
	selector: MEMBERSHIP_FORM_SELECTOR,
	setup(form) {
		initializeMembershipForm();
	}
});

// catch form rebuilds after Kentico validation failures
if (typeof MutationObserver !== 'undefined') {
	const observer = new MutationObserver(function(mutations) {
		let shouldCheck = false;

		mutations.forEach(function(mutation) {
			if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
				mutation.addedNodes.forEach(function(node) {
					if (node.nodeType === Node.ELEMENT_NODE) {
						if (node.querySelector && node.querySelector(MEMBERSHIP_FORM_SELECTOR)) {
							shouldCheck = true;
						}
					}
				});
			}
		});
		
		if (shouldCheck) {
			setTimeout(() => initializeMembershipForm(), 100);
		}
	});
	
	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
}

function initializeMembershipForm() {
	const forms = document.querySelectorAll(MEMBERSHIP_FORM_SELECTOR);
	
	forms.forEach(form => {
		const container = form.parentElement;

		if (container) {
			// check if this form already has our custom behavior
			const hasCustomBehavior = container.querySelector(MEMBERSHIP_FORM_DUMMY_ID);
			if (!hasCustomBehavior) {
				initCustomFormBehavior(container);
			}
		}

    removeMultiselectCheckboxRequired(form);
	});
}

function removeMultiselectCheckboxRequired(form) {
  const checkBoxLists = form.querySelectorAll('.ktc-checkbox-list');

  checkBoxLists.forEach(list => {
    const checkboxes = list.querySelectorAll('input[type="checkbox"]');

    if (checkboxes?.length && checkboxes.length > 1) {
      checkboxes.forEach((checkbox) => {
        checkbox.removeAttribute('required');
      });
    }
  });
}

function validateConditionalFields(form) {
	let isValid = true;
	let firstInvalidField = null;
	
	clearConditionalValidationErrors(form);
	
	// find all fields with conditional validation requirements
	const conditionalRequiredFields = form.querySelectorAll('[data-conditional-required="true"]');
	
	conditionalRequiredFields.forEach(field => {
		const dependsOn = field.getAttribute('data-validation-depends-on');
		const dependsValue = field.getAttribute('data-validation-depends-value');
		
		if (dependsOn && dependsValue) {
			let triggerCheckbox = null;

			const checkboxes = form.querySelectorAll(`input[name*="${dependsOn}"][type="checkbox"][value="true"]`);			
			checkboxes.forEach(checkbox => {
				const hiddenValueField = checkbox.parentElement.querySelector('input[type="hidden"][value="' + dependsValue + '"]');
				if (hiddenValueField) {
					triggerCheckbox = checkbox;
				}
			});
			
			if (triggerCheckbox && triggerCheckbox.checked && !field.classList.contains('hidden')) {
				const selectedCheckboxes = field.querySelectorAll('input[type="checkbox"]:checked');				
				if (selectedCheckboxes.length === 0) {
					const isFirstInvalid = !firstInvalidField;
					if (isFirstInvalid) {
						firstInvalidField = field;
					}
					showConditionalValidationError(field, isFirstInvalid);
					isValid = false;
				} else {
					// clear any existing validation errors if checkboxes are selected
					const inputs = field.querySelectorAll('input, textarea, select');
					inputs.forEach(input => {
						input.setCustomValidity('');
					});
				}
			}
		}
	});
	
	return isValid;
}

function showConditionalValidationError(field, shouldScroll = false) {
	// Kentico XbyK uses native HTML5 validation
	if (field.classList.contains('hidden') || field.offsetParent === null) {
		if (shouldScroll) {
			field.scrollIntoView({ 
				behavior: 'smooth', 
				block: 'center' 
			});
		}
		return;
	}

	const firstInput = field.querySelector('input[type="checkbox"], input[type="text"], input[type="email"], textarea, select');
	
	if (firstInput) {
		let message = 'This field is required.';
		if (firstInput.type === 'checkbox') {
			message = 'Please select at least one option.';
		} else if (firstInput.type === 'text' || firstInput.type === 'email' || firstInput.tagName === 'TEXTAREA') {
			message = 'Please fill out this field.';
		} else if (firstInput.tagName === 'SELECT') {
			message = 'Please select an option.';
		}

		firstInput.setCustomValidity(message);

		if (firstInput.offsetParent !== null && !firstInput.disabled) {
			firstInput.reportValidity();
		}

		if (shouldScroll) {
			field.scrollIntoView({ 
				behavior: 'smooth', 
				block: 'center' 
			});
		}
	}
}

function clearConditionalValidationErrors(form) {
	const conditionalFields = form.querySelectorAll('[data-conditional-required="true"]');
	conditionalFields.forEach(field => {
		const inputs = field.querySelectorAll('input, textarea, select');
		inputs.forEach(input => {
			input.setCustomValidity('');
		});
	});
}

function initCustomFormBehavior(container) {
	const formRoot = container.querySelector('form');
	if (!formRoot) {
		return;
	}
	
	// dummy element to identify whether customization is applied
	const customizeNode = document.createElement("span");
	customizeNode.id = MEMBERSHIP_FORM_DUMMY_ID;
	formRoot.appendChild(customizeNode);

	// form submission handling
	const oldSubmit = formRoot.onsubmit;
	formRoot.onsubmit = null
	
	formRoot.addEventListener("submit", (evt) => {
		const conditionalValidationPassed = validateConditionalFields(formRoot);
		if (!conditionalValidationPassed) {
			evt.preventDefault();
			return false;
		}

		const country = formRoot.querySelector('select[name*="Country"]').value;
		const products = [...formRoot.querySelectorAll('input[name*="Products"]:checked + label')].map((el) => el.innerText).join('|')
		const encodedProducts = encodeURIComponent(products);

		document.cookie = `Country=${country}; path=/; max-age=${60 * 60 * 24 * 14}`;
		document.cookie = `Products=${encodedProducts}; path=/; max-age=${60 * 60 * 24 * 14}`;
		
		if (oldSubmit) {
			oldSubmit.call(formRoot, evt);
		}

		return true;
	});

	// toggle for specific option
	const optionToggles = container.querySelectorAll('[data-toggle-option]')
	for (const formField of optionToggles) {

		let toggleValue = formField.dataset.toggleOption;

		const formFieldBelow = formField.nextElementSibling;
		if (!formFieldBelow) {
			continue;
		}
		
		const formInputBelow = formFieldBelow.querySelector(`input[type=text]`);
		const dropdown = formField.querySelector(`select`);

		dropdown.addEventListener("change", (evt) => {
		
			let selectedValue = evt.target.value;

			if (selectedValue == toggleValue) {
				formFieldBelow.classList.remove("hidden");

				// clear out the value so the user is required to enter something
				formInputBelow.value = ""; 

			} else {
				formFieldBelow.classList.add("hidden");

				// assign a default value so it passes validation
				formInputBelow.value = "NA"; 
			}

		});
	}

	// toggle for specific checkbox
	const checkboxToggles = container.querySelectorAll('[data-toggle-checkbox]')
	for (const formField of checkboxToggles) {

		let toggleValue = formField.dataset.toggleCheckbox;

		const formFieldBelow = formField.nextElementSibling;
		if (!formFieldBelow) {
			continue;
		}

		const formInputBelow = formFieldBelow.querySelector(`input[type=text]`);
		const inputWithValue = formField.querySelector(`input[value="${toggleValue}"]`);

		if (inputWithValue) {

			const toggleInput = inputWithValue.parentNode.querySelector(`input[type=checkbox]`);

			if (toggleInput) {

				toggleInput.addEventListener("click", () => {

					if (toggleInput.checked) {
						formFieldBelow.classList.remove("hidden");

						// clear out the value so the user is required to enter something
						if (formInputBelow) formInputBelow.value = "";

					} else {
						formFieldBelow.classList.add("hidden");

						// assign a default value so it passes validation
						if (formInputBelow) formInputBelow.value = "NA"; 
					}

				});

				// init
				if (toggleInput.checked) {
					formFieldBelow.classList.remove("hidden");
				} else {
					formFieldBelow.classList.add("hidden");
				}
			}
		}
	}

	// toggle for validation message when option is selected
	const validationMessageToggles = container.querySelectorAll('[data-validation-message]')
	for (const formField of validationMessageToggles) {

		let message = formField.dataset.validationMessage;

		// check for default error message rendered post form submission
		let messageNode = formField.querySelector(`.field-validation-error`);

		// create a placeholder (hidden) for the error message upon initial view
		if (!messageNode) {

			messageNode = document.createElement("div");
			messageNode.classList.add("field-validation-error");
			messageNode.classList.add("hidden");
			messageNode.innerHTML = message;

			const innerControl = formField.querySelector(`.editing-form-control-nested-control`);
			innerControl.appendChild(messageNode);
		}

		// get the option that will trigger a validation message
		let optionValueForMessage = formField.dataset.validationOption;
		const targetOption = formField.querySelector(`input[value="${optionValueForMessage}"]`);

		if (targetOption) {

			let inputName = targetOption.getAttribute("name");

			// bind each radio click to an event that checks for a validation message
			const options = formField.querySelectorAll(`input[name="${inputName}"]`);
			for (const option of options) {
				option.addEventListener("click", (evt) => {
					let radioValue = evt.target.value;

					if (radioValue.trim() == optionValueForMessage) {
						messageNode.classList.remove("hidden");
						messageNode.innerHTML = message;
					} else {
						messageNode.classList.add("hidden");
					}
				});
			}
		}
	}
}